import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';

export default function EditGallery() {
    const { id } = useParams();
    const [name, setName] = useState('');
    const [category, setCategory] = useState('');
    const [date, setDate] = useState('');
    const [locationOrigin, setLocationOrigin] = useState('');
    const [locationFinish, setLocationFinish] = useState('');
    const [image, setImage] = useState(null);
    const [currentImage, setCurrentImage] = useState(null);
    const api = "https://apibbytowing.vercel.app";

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${api}/api/get/${id}`);
                const data = response.data.data[0];
                setName(data.name);
                setCategory(data.category);
                setDate(data.date ? data.date.split('T')[0] : '');
                setLocationOrigin(data.location_origin);
                setLocationFinish(data.location_finish);
                setCurrentImage(data.image);
                if (data.image) {
                    document.getElementById('image-preview').src = `${api}${data.image}`;
                    document.getElementById('image-preview-container').classList.remove('hidden');
                }
            } catch (error) {
                console.error("Error fetching gallery data:", error);
            }
        };

        if (id) {
            fetchData();
        }
    }, [id]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('name', name);
        formData.append('category', category);
        formData.append('date', date);
        formData.append('location_origin', locationOrigin);
        formData.append('location_finish', locationFinish);
        formData.append('image', image || currentImage);

        const accessToken = localStorage.getItem('accessToken');
        if (!accessToken) {
            alert('No token found. Please log in.');
            return;
        }

        try {
            const response = await axios.put(`${api}/api/edit/${id}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${accessToken}`
                }
            });
            alert(response.data.message);
        } catch (error) {
            console.error('Error updating post:', error.message);
            alert('Failed to update. Error: ' + error.message);
        }
    };

    const previewImage = (event) => {
        const fileInput = event.target;
        const file = fileInput.files[0];

        if (file) {
            setImage(file);
            const reader = new FileReader();
            reader.onload = (e) => {
                const imagePreview = document.getElementById('image-preview');
                imagePreview.src = e.target.result;
                imagePreview.parentElement.classList.remove('hidden');
            };
            reader.readAsDataURL(file);
        } else {
            setImage(null);
            const imagePreview = document.getElementById('image-preview');
            imagePreview.src = '#';
            imagePreview.parentElement.classList.add('hidden');
        }
    };

    return (
        <div className="flex flex-col-reverse md:flex-row items-center justify-center gap-6 py-24 w-full h-full">
            <div id="image-preview-container" className={currentImage || image ? '' : 'hidden'}>
                <img id="image-preview" src={currentImage ? `${api}${currentImage}` : '#'} alt="Preview" className="max-w-full max-h-96" />
            </div>
            <section className="border p-6 rounded-xl shadow-lg w-[400px] bg-[#fcfc00c0]">
                <form method="POST" onSubmit={handleSubmit}>
                    <div className="flex flex-col gap-6">
                        <div className="relative">
                            <input
                                type="text"
                                placeholder='Nama Kendaraan'
                                required
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                className="w-full bg-[#fcfc00c0] border-b-2 border-black focus:outline-none focus:border-gray-300 py-2"
                            />
                        </div>
                        <div className="relative">
                            <select
                                value={category}
                                onChange={(e) => setCategory(e.target.value)}
                                className="w-full bg-[#fcfc00c0] border-b-2 border-black outline-none focus:outline-none focus:border-gray-300 py-2"
                            >
                                <option>Pilih Kategori</option>
                                <option value="Jasa Derek Mobil">Jasa Derek Mobil</option>
                                <option value="Jasa Derek Motor">Jasa Derek Motor</option>
                            </select>
                        </div>
                        <div className="relative">
                            <input
                                type="date"
                                required
                                value={date}
                                onChange={(e) => setDate(e.target.value)}
                                className="w-full bg-[#fcfc00c0] border-b-2 border-black focus:outline-none focus:border-gray-300 py-2"
                            />
                        </div>
                        <div className="relative">
                            <input
                                type="text"
                                placeholder='Keberangkatan'
                                required
                                value={locationOrigin}
                                onChange={(e) => setLocationOrigin(e.target.value)}
                                className="w-full bg-[#fcfc00c0] border-b-2 border-black focus:outline-none focus:border-gray-300 py-2"
                            />
                        </div>
                        <div className="relative">
                            <input
                                type="text"
                                placeholder='Destinasi'
                                required
                                value={locationFinish}
                                onChange={(e) => setLocationFinish(e.target.value)}
                                className="w-full bg-[#fcfc00c0] border-b-2 border-black focus:outline-none focus:border-gray-300 py-2"
                            />
                        </div>
                        <div className="relative">
                            <input
                                type="file"
                                className="w-full bg-[#fcfc00c0] border-b-2 border-black focus:outline-none focus:border-gray-300 py-2"
                                onChange={previewImage}
                            />
                        </div>
                        <button
                            type="submit"
                            className="bg-black hover:bg-black flex flex-row justify-between px-4 py-3 rounded-xl shadow-md"
                        >
                            <p className="font-bold text-white">Update Gallery</p>
                        </button>
                    </div>
                </form>
            </section>
        </div>
    );
}
